<template>
  <div class="wrapper">
    <div class="switch-wrapper">
      <v-switch
        v-model="switchValue"
        :key="confirmingToggle"
        :disable="confirmingToggle"
        :label="`Status: ${organization.hidden ? 'Hidden' : 'Visible'}`"
        :false-value="true" :true-value="false"
        @change="handleChange" />

        <p v-if="organization.hidden" class="help">
          This organization is hidden. It will not be displayed for any future questionnaire results. Any lender accounts with access to this organization will not be able to view it. If any of its products are part of an active deal, those will still be visible.
        </p>
        <p v-else class="help">
          This organization is currently visible
        </p>
    </div>

    <h2>Users In Organization:</h2>
    <dl class="grid-wrapper">
      <dt></dt>
      <dt>Name</dt>
      <dt>Email</dt>

      <template v-for="user in users">
        <button
          :key="user.id"
          class="default-btn text text-red minimal"
          @click="removeUserFromOrganization(user.id)"
        ><v-icon color="inherit">mdi-minus</v-icon></button>
        <dd :key="user.fullName">{{ user.fullName }}</dd>
        <dd :key="user.email">{{ user.email }}</dd>
      </template>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'OrganizationUsersList',
  props: {
    organization: {
      type: Object,
      default: () => ({}),
    },
    users: {
      type: Array,
      default: () => [],
    },
    confirmingToggle: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    switchValue: false,
  }),

  created () {
    this.switchValue = this.organization.hidden
  },

  watch: {
    confirmingToggle () {
      this.switchValue = this.organization.hidden
    },
    organization () {
      this.switchValue = this.organization.hidden
    },
  },

  methods: {
    async removeUserFromOrganization (id) {
      this.$emit('removedUser', {
        organizationId: this.organization.id,
        userId: id,
      })
    },

    handleChange ($event) {
      this.$emit('toggleHidden', $event)
      this.switchValue = this.organization.hidden
    },
  },
}
</script>

<style lang="scss" scoped>
div.wrapper {
  padding: 10px;
}

.grid-wrapper {
  width: 100%;
  margin: 20px 0;

  display: grid;
  justify-content: flex-start;
  align-items: center;

  grid-template-columns: 20px auto auto;
  grid-template-rows: auto;
  grid-column-gap: 30px;
  grid-row-gap: 5px;

  dt {
    font-family: "Sansation Bold", sans-serif;
    font-size: 16px;
  }
}

.switch-wrapper {
  display: flex;
  flex-direction: column;

  ::v-deep {
    .v-label {
      top: 5px;
    }
  }
}

.v-input--switch {
  margin-top: -5px;
  margin-bottom: -5px;
}
</style>
